// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
// import AddIcon from '@material-ui/icons/Add';
import LinkIcon from '@material-ui/icons/Link';
import DeleteIcon from '@material-ui/icons/Delete';
import HelpIcon from '@material-ui/icons/Help';
// import CloseIcon from '@material-ui/icons/Close';
// import PersonIcon from '@material-ui/icons/Person';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import OutlinedPopover from '../ui/OutlinedPopover';
import ClioGrowHelp from './ClioGrowHelp';
import EmailHelp from './EmailHelp';

import * as ServiceIcons from './Icons';
import * as coreActions from '../core/actions';

import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import TuneIcon from '@material-ui/icons/Tune';

import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';


const styles = theme => ({
  /* Raised box around the content */
  contentBox : {
    // width: '100%',
    // height: '100%',
    // borderRadius: 20,
    // padding: 20,
    // display: 'flex',,
    // border:'1px solid #cccdd2',
    padding: 20,
    minHeight: '50vh'
  },
  
  /* Scrolled area inset from the content box */
  contentScroller : {
    overflow: 'auto',
    width: '100%',
  },

  /* Top control area with search box and add content */
  controlPanel : {
    display: 'flex',    
    alignItems: 'center',
  },

  /* Search input in the control panel */
  searchInput : {
    fontSize: 12,
    height: 30,
  },
  

  /* Link list container */
  linkList : {
    marginRight: 20,
  },

  /* Link row */
  linkRow: {
    display: 'flex',
    marginBottom: 20,
    marginRight: 30,
  },

  /* Left side icon */
  peopleIcon : {
    marginLeft: 20,
    display: 'flex',
    alignItems: 'center',
  },

  /* Clickable center area with contact name */
  infoBlock : {
    flexGrow: '1',
    paddingLeft: 10,
    '&:hover' : {
      background: theme.palette.grey[200],
    },
  },

  /* Top name line in the info block */
  name: {
    fontFamily: 'Sofia-bold'
  },
  /* Bottom business name line in the info block */
  business: {
    fontFamily: 'Sofia'
  },
  

  /* Right side menu */
  menuBlock : {
    display: 'flex',
    alignItems: 'center',
  },

  /* Section row at the start of each letter */
  sectionRow: {
    marginLeft: 20,
    marginRight: 20,
    marginTop: 20,   
    ...theme.typography.body2,
    fontWeight: 'bold',
  },

  /* Text when re-authorization a link */
  linkBlurb : {
    ...theme.typography.body1,
    fontFamily: 'Sofia'
  },

  

  ruleChangeDialog:{
    padding:theme.spacing(2),
    color:'white',
  },

  ruleList:{
     marginBottom:theme.spacing(2)
  },
});


/*
 * External service links
 */

class Links extends Component {
  state = {
    authorizeOpen: false,
    newLinkOpen: false,
    deleteOpen : false,
    serviceParamInbox:"",
    email:"",
    phone:"",
    randomVerifyTokenGenerated:"",
    randomVerifyTokenUser:"",
    transferServiceId: '',
    linkMenuOpen : false,
    linkMenuElement : undefined,
    transferLink: {},
    linkBlurb : '',
    emailHelpOpen : false,
    emailHelpAnchor : undefined,
    clioGrowHelpOpen : false,
    clioGrowHelpAnchor : undefined,
    customRulesOpen : false,
    enableTransferOpen : false,
    disableTransferOpen : false,
    backFillOpen : false,
    transferRuleMenuOpen:false,
    addTransferRuleOpen:false,
    denyOption:'N',
    ruleType:'accountId',
    apiKey:"",
    ruleValue:'',
    groupRuleValue: [],
    usedRuleAccounts:[],
    usedRulePhoneNumbers:[],
  }

  /* Open the popup to create a new link */
  newLink = () => {
    this.props.updateTransferServices();
    this.setState({newLinkOpen: true, transferServiceId: '' });
  }

  /* What we do when they click on an existing link depends on the status */
  openLink = (transferLink) => {
    let linkBlurb = '';
    switch (transferLink.transferKey) {
      case 'POWERA':
        linkBlurb =
          <div>
            <span>This link is managed from </span>
            <MuiCore.Link href='https://us.flow.microsoft.com/' target='_blank' rel='noreferrer'>Power Automate.</MuiCore.Link>
          </div>;
        break;
      case 'ZAPIER':
        linkBlurb =
          <div>
            <span>This link is managed from </span>
            <MuiCore.Link href='https://zapier.com/app/login' target='_blank' rel='noreferrer'>Zapier.</MuiCore.Link>
          </div>;
        break;
      case 'CLIOGROW' || 'EMAIL':
        if (transferLink.settingUp === 'Y') {
          linkBlurb = 'The authorization on this link is not complete.  Enter your INBOX token and click authorize.';
        } else {
          if (transferLink.attention === 'Y') {
            linkBlurb = 'There was a problem with the authorization for this link.  Enter an updated INBOX token and click authorize.';
          } else {
            // linkBlurb = 'This link has an active authorization.  If you wish to change the the authorization, enter a new INBOX token and click authorize';
            linkBlurb = 'This link has an active authorization. Re-verify and authorize if you wish to update the authorization or change the link to a different account.';
          }
        }
        break;
      default:
        if (transferLink.settingUp === 'Y') {
          linkBlurb = 'The authorization on this link is not complete.  Click the authorize button to go to the partner system and grant access.';
        } else {
          if (transferLink.attention === 'Y') {
            linkBlurb = 'There was a problem with the authorization for this link.  Click the authorize button to go to the partner system and grant access.';
          } else {
            // linkBlurb = 'This link has an active authorization.  Click the authorize button if you wish to update the authorization or change the link to a different account.';
            linkBlurb = 'This link has an active authorization. Re-verify and authorize if you wish to update the authorization or change the link to a different account.';
          }
        }
    }
    this.setState({ authorizeOpen : true, transferLink, linkBlurb, serviceParamInbox : '', });
  }

  openTransferRules = () => {
    if (this.customTransfers(this.state.transferLink)) {
      this.setState({ customRulesOpen: true, linkMenuOpen: false,});
    }
    if (this.manualTransfers(this.state.transferLink)) {
       this.setState({ enableTransferOpen: true, linkMenuOpen: false,});
    }
    if (this.transferAll(this.state.transferLink)) {
      this.setState({ disableTransferOpen: true, linkMenuOpen: false,});
    }
  }

  closeLink = () => {
    this.setState({ authorizeOpen : false, newLinkOpen : false });
  }

  handleChange = (event) => {
    this.setState({ serviceParamInbox : event.target.value });
  }

  handleEmailChange = (event) => {
    this.setState({ email : event.target.value });
  }

  handleSelectFlag = (info, countryData, value,status) => {
    //console.log("handleSelectFlag",info, countryData, value,status)
    this.setState({ countryData:countryData});
    
  }

  handleEmailChange = (event) => {
    this.setState({ email : event.target.value });
  }

  handlePhoneChange = (event) => {
    this.setState({ phone : event.target.value });
  }

  handleIntlPhoneChange = (status, value, countryData, number, id) => {
    //console.log("handlePhoneChange",status, value, countryData, number, id)
      this.setState({ phone : value,countryData:countryData,phoneValidation:status});
  }

  handleApiKeyChange = (event) => {
    this.setState({ apiKey : event.target.value });
  }  
  
  handleVerifyTokenChange = (event) => {
    this.setState({ randomVerifyTokenUser : event.target.value });
  }  

  openMenu = (event, transferLink) => {
    this.setState({linkMenuElement : event.currentTarget,
                   linkMenuOpen : true,
                   transferLink});
  }
  
  sendVerificationEmail = (event) =>{
    var randomCode  =Math.random().toString().substr(2, 5);
    this.setState({randomVerifyTokenGenerated:randomCode})
    var phone = this.state.phone;
    if(this.state.countryData && this.state.phone && this.state.phone.length > 1){
        phone = "+"+this.state.countryData.dialCode + phone;
    }
    this.props.sendVerificationCode(this.state.email,phone,randomCode)
  }
  /* Check if transfers are manual */
  manualTransfers = (transferLink) => {
    return((transferLink.transferRules || []).length === 0);
  }

  /* Check if transferring all messages */
  transferAll = (transferLink) => {
    let all = false;
    (transferLink.transferRules || []).every(rule => {
      if (rule.matchAll === 'Y' && rule.deny === 'N' && !rule.accountId
          && !rule.phoneNumberId && !rule.messageCategoryId) {
        all = true;
        return(true);
      } else {
        all = false;
        return(false);
      }
    });
    return(all);
  }

  /* Custom rules changable by this UI */
  customTransfers = (transferLink) => {
    let custom = false;
    (transferLink.transferRules || []).every(rule => {
      if (rule.matchAll !== 'Y' || rule.deny !== 'N' || rule.accountId
          || rule.phoneNumberId || rule.messageCategoryId) {
        custom=true;
        return(false);
      }
      return(true);
    });
    return(custom);
  }

  createLink = (transferServiceId, token) => {
    this.setState({ newLinkOpen: false});
    if(transferServiceId === 6 ){
      this.props.createTransferLink(transferServiceId, this.state.email);
    }
    else  if(transferServiceId === 8 ){
      this.props.createTransferLink(transferServiceId, this.state.email,this.state.apiKey);
    }
    else if(transferServiceId === 7 ){
      this.props.createTransferLink(transferServiceId, this.state.phone);
    }
    else{
      this.props.createTransferLink(transferServiceId, token);
    }
    
  }

  createCustomRule = () => {
    this.setState({ addTransferRuleOpen: false,transferRuleMenuOpen:false, groupRuleValue: []});
    this.props.addNewCustomTransferRule(this.state.transferLink.transferLinkId, this.state.denyOption,this.state.ruleType,this.state.groupRuleValue);
  }

  deleteCustomRule = (transferLinkId,transferRuleId) => {
    this.setState({ addTransferRuleOpen: false,transferRuleMenuOpen:false});
    this.props.deleteCustomTransferRule(transferLinkId, transferRuleId);
  }
  
  
  deleteLink = (transferLinkId) => {
    this.setState({ deleteOpen: false});
    this.props.deleteTransferLink(transferLinkId);
  }
  
  refreshLink = (transferLink, token,email,phone,apiKey) => {
    this.setState({ authorizeOpen : false});
    if(transferLink.transferKey === "EMAIL" ){
      if(this.state.randomVerifyTokenGenerated === this.state.randomVerifyTokenUser){
        this.props.refreshTransferLink(transferLink, email);
      }
      else{
        
      }
    }
    else if(transferLink.transferKey === "INFLUXMD" ){
      if(this.state.randomVerifyTokenGenerated === this.state.randomVerifyTokenUser){
        this.props.refreshTransferLink(transferLink, email,apiKey);
      }
      else{
        
      }
    }
    else if(transferLink.transferKey === "TWILIO" ){
      if(this.state.randomVerifyTokenGenerated === this.state.randomVerifyTokenUser){
        this.props.refreshTransferLink(transferLink, phone);
      }
      else{
        
      }
    }
    else{
      this.props.refreshTransferLink(transferLink, token);
    }
  }
  
  backFillLink = (transferLinkId) => {
    this.setState({ backFillOpen : false});
    this.props.backfillTransferLink(transferLinkId);
  }

  enableTransfer = () => {
    this.setState({ enableTransferOpen : false});
    this.props.enableAutomaticTransfers(this.state.transferLink.transferLinkId);
  }

  disableTransfer = () => {
    this.setState({ disableTransferOpen : false});
    this.props.disableAutomaticTransfers(this.state.transferLink.transferLinkId);  
  }

  getAccountName = (accountId) => {
    return this.props.user.userAccountRoles?.filter(account => account.accountId === accountId)[0]?.accountName || '';
  }

  render() {
    const { classes, user, transferServices, importContacts  } = this.props;
    const { authorizeOpen, newLinkOpen, linkMenuOpen, deleteOpen,
            transferLink, linkBlurb, transferServiceId,
            clioGrowHelpOpen, clioGrowHelpAnchor, emailHelpOpen, emailHelpAnchor, 
            customRulesOpen, enableTransferOpen, disableTransferOpen, backFillOpen,transferRuleMenuOpen,addTransferRuleOpen } = this.state;

    let transferService = {};
    if (transferServices && transferServiceId) {
      transferService = transferServices.find(service => service.transferServiceId === transferServiceId);
    }

    let transferLinks = user.transferLinks || [];

    var distinctAccounts=[];    

    var disableTransfers = false;

    var accounts = (this.props.user.userAccountRoles || [])
    .filter((role,index,arr) => {

      if(role.userRoleKey !=='INACTIVE' && role.hipaa && role.hipaa ==='Y'){
        disableTransfers=true;
      }

    if(role.userRoleKey === 'GLOBALADMIN' && distinctAccounts.indexOf(role.accountId) === -1){
      distinctAccounts.push(role.accountId)
      return true;
    }else{
      return false;
    }
  });


    let phoneNumbers = user.patchNumbers || [];

    let linksOption = 'Enable Automatic Transfers';
    if (!this.manualTransfers(transferLink)) {
      linksOption = 'Disable Automatic Transfers';
    }

    return (
      <React.Fragment>
        <ClioGrowHelp open={clioGrowHelpOpen}
                      anchorEl={clioGrowHelpAnchor}
                      onClose={() => this.setState({ clioGrowHelpOpen : false })}/>

        <EmailHelp open={emailHelpOpen}
                      anchorEl={emailHelpAnchor} type={transferService.transferKey}
                      onClose={() => this.setState({ emailHelpOpen : false })}/>
        
        <MuiCore.Menu anchorEl={this.state.linkMenuElement}
                      onClose={() => this.setState({linkMenuOpen: false})}
                      transformOrigin={{
                        horizontal : 'right',
                        vertical: 'top',
                      }}
                      open={linkMenuOpen}>
          <MuiCore.MenuItem onClick={this.openTransferRules}>
            {linksOption}
          </MuiCore.MenuItem>
          <MuiCore.Divider/>

             <MuiCore.MenuItem
                disabled={transferLink.settingUp === 'Y' || (transferLink.transferRules && transferLink.transferRules.filter(rule => rule.matchAll ==='Y').length > 0 )}
                onClick={() => 
                {
                  var usedRulePhoneNumbers = [],usedRuleAccounts = [];
    
                          transferLink.transferRules.forEach(element => {
                            if(element.accountId){
                              usedRuleAccounts.push(element.accountId);
                            }
                            if(element.phoneNumberId){
                              usedRulePhoneNumbers.push(element.phoneNumberId);
                            }
                          });
                          this.setState({backFillOpen : false, linkMenuOpen: false,transferRuleMenuOpen:true,usedRulePhoneNumbers:usedRulePhoneNumbers,usedRuleAccounts:usedRuleAccounts})
                }
                  }>
                Modify Rules{transferLink?.transferRules?.filter(rule => rule.matchAll !=='Y').length > 0 && `(${transferLink?.transferRules?.filter(rule => rule.matchAll !=='Y').length})`}
              </MuiCore.MenuItem>
              <MuiCore.Divider/>

          <MuiCore.MenuItem
            disabled={transferLink.settingUp === 'Y'}
            onClick={() => this.setState({backFillOpen : true, linkMenuOpen: false})}>
            Back Fill
          </MuiCore.MenuItem>
          <MuiCore.Divider/>
          <MuiCore.MenuItem
            disabled={transferLink.settingUp === 'Y' || !['CLIO'].includes(transferLink.transferKey)}
            onClick={() => {
              importContacts(transferLink.transferLinkId);
              this.setState({linkMenuOpen: false})
            }}>
            Import contacts
          </MuiCore.MenuItem>
          <MuiCore.Divider/>
          <MuiCore.MenuItem onClick={() => this.setState({deleteOpen : true, linkMenuOpen: false})}>
            Delete Link
          </MuiCore.MenuItem>
        </MuiCore.Menu>
        
        <MuiCore.Dialog open={deleteOpen}
                        onClose={() => this.setState({deleteOpen: false })}>
          <MuiCore.DialogTitle>
            Delete Link
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              Are you sure you want to delete the link to {transferLink.serviceName}?  This will stop
              all new transfers and remove your credentials.
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={() => this.deleteLink(transferLink.transferLinkId)}>
              Delete
            </MuiCore.Button>
            <MuiCore.Button onClick={() => this.setState({deleteOpen: false})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
        <MuiCore.Dialog open={backFillOpen}
                        onClose={() => this.setState({backFillOpen: false })}>
          <MuiCore.DialogTitle>
            Back Fill
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              This will transfer any of your messages to the service link that have not already been sent.
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={() => this.backFillLink(transferLink.transferLinkId)}>
              Back Fill
            </MuiCore.Button>
            <MuiCore.Button onClick={() => this.setState({backFillOpen: false})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>

        <MuiCore.Dialog open={transferRuleMenuOpen}
                        onClose={() => this.setState({transferRuleMenuOpen: false })}>
          <MuiCore.DialogTitle>
            Modify Transfer Rules
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
             Add or Delete transfer rules which will define the information that flows to your transfer link
            </MuiCore.DialogContentText>
            {transferLink.transferRules && transferLink.transferRules.filter(rule => rule.matchAll !=='Y').length > 0 && 
            
            <MuiCore.List dense className={classes.ruleList}>
                        { transferLink.transferRules.filter(rule => rule.matchAll !=='Y').map((item) => 
                              <MuiCore.ListItem>
                              <MuiCore.ListItemAvatar>
                                  <MuiCore.Avatar>
                                     <TuneIcon />
                                  </MuiCore.Avatar>
                              </MuiCore.ListItemAvatar>
                              <MuiCore.ListItemText
                                primary={
                                    <MuiCore.Typography>
                                    Rule {item.deny ==='Y' ? 'Deny':'Allow'} - {item.accountName} {item.phoneNumber} {item.messageGroupId ? `${item.messageGroupName} (${this.getAccountName(item.messageGroupAccountId)})` : ''}
                                    </MuiCore.Typography> 
                                }
                              />
                              <MuiCore.ListItemSecondaryAction>
                                <MuiCore.IconButton edge="end" aria-label="delete">
                                  <DeleteIcon color="secondary" onClick={() => this.deleteCustomRule(transferLink.transferLinkId,item.transferRuleId)} />
                                </MuiCore.IconButton>
                              </MuiCore.ListItemSecondaryAction>
                              </MuiCore.ListItem>
                        )}
                        </MuiCore.List>

            }
            

                        <MuiCore.Divider />

                        {addTransferRuleOpen && 
                          <MuiCore.Grid container style={{background:'white',padding:'16px'}} spacing={2}>
                            <MuiCore.Grid item xs={12}>
                              {/* <MuiCore.FormControl fullWidth  style={{color:'white'}}>
                                <MuiCore.InputLabel id="denylabel">Option</MuiCore.InputLabel>
                                <MuiCore.Select labelId="denylabel"
                                                id="denyInput"
                                                value={this.state.denyOption}
                                                onChange={(event) => { this.setState({denyOption : event.target.value }) }}>
                                    <MuiCore.MenuItem 
                                                      value="Y">
                                      Deny
                                    </MuiCore.MenuItem>
                                    <MuiCore.MenuItem 
                                                      value="N">
                                      Allow
                                    </MuiCore.MenuItem>
                                </MuiCore.Select>
                              </MuiCore.FormControl> */}
                            </MuiCore.Grid>
                            <MuiCore.Grid item xs={12}>
                              <MuiCore.FormControl fullWidth >
                              <MuiCore.FormLabel component="legend">Rule Type</MuiCore.FormLabel>
                                  <MuiCore.RadioGroup style={{color:'black'}} aria-label="gender" name="gender1" value={this.state.ruleType}  onChange={(event) => { this.setState({ruleType : event.target.value, groupRuleValue: [] }) }} >
                                    <MuiCore.FormControlLabel value="accountId" control={<MuiCore.Radio />} label="Account" />
                                    <MuiCore.FormControlLabel value="phoneNumberId" control={<MuiCore.Radio />} label="Phone Number" />
                                    {user?.userAccountRoles?.filter(user => user.userRoleKey === 'GLOBALADMIN').length > 0 && <MuiCore.FormControlLabel value="messageGroupId" control={<MuiCore.Radio />} label="Profiles" />}
                                  </MuiCore.RadioGroup>
                              </MuiCore.FormControl>
                            </MuiCore.Grid>
                            
                            
                           {this.state.ruleType === 'accountId' && <MuiCore.Grid item xs={12}>
                            <MuiCore.FormControl fullWidth>
                                <MuiCore.InputLabel id="accountSellabel">Select Account</MuiCore.InputLabel>
                                <MuiCore.Select labelId="accountSellabel"
                                                id="accountSel"
                                                value={this.state.groupRuleValue}
                                                multiple
                                                onChange={(event) => { this.setState({groupRuleValue : event.target.value }) }}>
                                                  {accounts.filter(element => this.state.usedRuleAccounts.indexOf(element.accountId) === -1 ).map((item) => 
                                                  <MuiCore.MenuItem 
                                                    value={item.accountId}>
                                                  { item.accountName}
                                                  </MuiCore.MenuItem>
                                                  
                                                  )}
                                    
                                    
                                </MuiCore.Select>
                              </MuiCore.FormControl>
                            </MuiCore.Grid>} 

                            {this.state.ruleType === 'phoneNumberId' && <MuiCore.Grid item xs={12}>
                            <MuiCore.FormControl fullWidth>
                                <MuiCore.InputLabel id="accountSellabel">Select Phone Number</MuiCore.InputLabel>
                                <MuiCore.Select labelId="accountSellabel"
                                                id="accountSel"
                                                value={this.state.groupRuleValue}
                                                multiple
                                                onChange={(event) => { this.setState({groupRuleValue : event.target.value }) }}>
                                                  {phoneNumbers.map((item) => 
                                                  <MuiCore.MenuItem 
                                                    value={item.phoneNumberId}>
                                                  { item.phoneNumber}
                                                  </MuiCore.MenuItem>
                                                  
                                                  )}
                                    
                                    
                                </MuiCore.Select>
                              </MuiCore.FormControl>
                            </MuiCore.Grid>} 

                            {this.state.ruleType === 'messageGroupId' && <MuiCore.Grid item xs={12}>
                            <MuiCore.FormControl fullWidth>
                                <MuiCore.InputLabel id="messageGroup">Select Profiles</MuiCore.InputLabel>
                                <MuiCore.Select labelId="messageGroupLabel"
                                                id="messageGroupSel"
                                                multiple
                                                MenuProps={{
                                                  getContentAnchorEl: () => null,
                                                }}
                                                value={this.state.groupRuleValue}
                                                onChange={(event) => { this.setState({groupRuleValue : event.target.value }) }}>
                                                  {user?.userAccountRoles?.map(account => account?.messageGroups?.map(item => 
                                                    <MuiCore.MenuItem 
                                                      value={item.messageGroupId}>
                                                      {`${item.name} (${account.accountName})`} 
                                                    </MuiCore.MenuItem>
                                                  ))}
                                    
                                    
                                </MuiCore.Select>
                              </MuiCore.FormControl>
                            </MuiCore.Grid>} 
                            
                          
                          </MuiCore.Grid>
                        }

          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            {this.state.addTransferRuleOpen && 
              <MuiCore.Button onClick={this.createCustomRule} disabled={this.state.groupRuleValue.length === 0}>
              Save
              </MuiCore.Button>
            }

            {!this.state.addTransferRuleOpen && 
               <MuiCore.Button onClick={() => this.setState({addTransferRuleOpen: true})}>
               Add
             </MuiCore.Button>
            }
            <MuiCore.Button onClick={() => this.setState({transferRuleMenuOpen: false, groupRuleValue: []})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
        

        <OutlinedPopover open={newLinkOpen}
                         icon={<LinkIcon color='primary' fontSize='large'/>}
                         title="New Service Link"
                         onClose={() => this.setState({newLinkOpen : false})}>
          <MuiCore.Grid container 
          style={{ maxWidth: 500}}
           spacing={2}>
            <MuiCore.Grid item xs={12}>
              <MuiCore.Typography style={{fontFamily: 'Sofia'}}>
                Select the service you wish to transfer your messages.  You will be redirected to that service so you
                can login and confirm the access permissions.  You may revoke this access at any time.
              </MuiCore.Typography>                
            </MuiCore.Grid>
            <MuiCore.Grid item xs={12}>
              <MuiCore.FormControl fullWidth>
                <MuiCore.InputLabel id="serviceInputLabel" style={{fontFamily: 'Sofia'}}>Service</MuiCore.InputLabel>
                <MuiCore.Select labelId="serviceInputLabel"
                                id="serviceInput"
                                style={{fontFamily: 'Sofia'}}
                                value={this.state.transferServiceId}
                                onChange={(event) => { this.setState({transferServiceId : event.target.value,randomVerifyTokenUser:"",randomVerifyTokenGenerated:"",email:"" }) }}>
                  {(transferServices || []).filter(transferService => {
                    if (transferService.pullService === 'Y') {
                      return(false);
                    }
                    if(transferService.transferKey !== 'EMAIL' && transferService.transferKey !== 'TWILIO')
                    {
                      return !disableTransfers;
                    }
                    if(transferService.transferKey === 'EMAIL'){

                      return (true);
                    }
                    if(transferService.transferKey === 'TWILIO'){

                      return (true);
                    }
                    return transferLinks.map(link => link.transferServiceId).indexOf(transferService.transferServiceId) === -1
                  }).map(transferService => (
                    <MuiCore.MenuItem key={transferService.transferServiceId}
                                      style={{fontFamily: 'Sofia'}}
                                      value={transferService.transferServiceId}>
                      {transferService.name}
                    </MuiCore.MenuItem>
                  ))}
                </MuiCore.Select>
              </MuiCore.FormControl>
            </MuiCore.Grid>
            
            {transferService.transferKey === 'CLIOGROW' &&
             <MuiCore.Grid item xs={12}>
               <div style={{ display: 'flex'}}>
                 <div style={{flexGrow: 1}}>
                   <MuiCore.FormControl fullWidth>
                     <MuiCore.TextField id="serviceParamToken"
                                        fullWidth
                                        style={{fontFamily: 'Sofia'}}
                                        InputProps={{ style: {fontFamily: 'Sofia', fontSize: 18}}}
                                        variant="standard"
                                        placeholder="Inbox Token" value={this.state.serviceParamInbox} onChange={this.handleChange} />
                   </MuiCore.FormControl>                     
                 </div>
                 <div>
                   <MuiCore.IconButton color='primary' onClick={(event) => {
                     this.setState({clioGrowHelpOpen: true, clioGrowHelpAnchor: event.target });
                   }}>
                     <HelpIcon/>
                   </MuiCore.IconButton>
                 </div>
               </div>
             </MuiCore.Grid>
            }

            {(transferService.transferKey === 'EMAIL' || transferService.transferKey === 'TWILIO' || transferService.transferKey === 'INFLUXMD' ) &&
                    <MuiCore.Grid item xs={12}>
                      <div style={{ display: 'flex'}}>
                        <div style={{flexGrow: 1}}>
                          <MuiCore.FormControl fullWidth>
                           {(transferService.transferKey === 'EMAIL' || transferService.transferKey === 'INFLUXMD')&& <MuiCore.TextField id="email"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                placeholder="Email Address" value={this.state.email} onChange={this.handleEmailChange} /> }

                            {transferService.transferKey === 'TWILIO' &&  <IntlTelInput  containerClassName="intl-tel-input"
                              inputClassName="MuiInputBase-input" defaultCountry="us" preferredCountries={[]}  onlyCountries={['us','gb']} value={this.state.phone} onPhoneNumberChange={this.handleIntlPhoneChange} onSelectFlag={this.handleSelectFlag} />}


                             {/* {transferService.transferKey === 'TWILIO' &&  <MuiCore.TextField id="phone"
                                                fullWidth
                                                variant="standard"
                                          label="Phone Number" value={this.state.phone} onChange={this.handlePhoneChange} /> } */}
                          </MuiCore.FormControl> 

                          <MuiCore.FormControl style={{marginTop:'10px'}}>
                          <MuiCore.Button disabled={this.state.randomVerifyTokenGenerated !=="" || (this.state.transferServiceId === 7 && !this.state.phoneValidation)}
                           onClick={() => this.sendVerificationEmail()}>Verify</MuiCore.Button>
                        </MuiCore.FormControl>

                          {this.state.randomVerifyTokenGenerated && 
                          <MuiCore.FormControl fullWidth>
                            <MuiCore.TextField id="verifyToken"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                placeholder="Enter Verification Code" value={this.state.randomVerifyTokenUser} onChange={this.handleVerifyTokenChange} />
                          </MuiCore.FormControl>  
                          }  

                          {transferService.transferKey === 'INFLUXMD'  && this.state.randomVerifyTokenGenerated && 
                          <MuiCore.FormControl fullWidth>
                            <MuiCore.TextField id="apiKey"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                placeholder="Enter Api Key" value={this.state.apiKey} onChange={this.handleApiKeyChange} />
                          </MuiCore.FormControl>  
                          }

                        </div>
                        <div>
                          <MuiCore.IconButton color='primary' onClick={(event) => {
                            this.setState({emailHelpOpen: true, emailHelpAnchor: event.target });
                          }}>
                            <HelpIcon/>
                          </MuiCore.IconButton>
                        </div>
                      </div>
                    </MuiCore.Grid>
                    }
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.Button disabled={!this.state.transferServiceId || (this.state.transferServiceId === 3 && this.state.serviceParamInbox.length === 0) || (this.state.transferServiceId === 6 && this.state.randomVerifyTokenGenerated ==="") || (this.state.transferServiceId === 7 && this.state.randomVerifyTokenGenerated ==="") || (this.state.transferServiceId === 6 && this.state.randomVerifyTokenGenerated !=="" && this.state.randomVerifyTokenGenerated !== this.state.randomVerifyTokenUser) || (this.state.transferServiceId === 7 && this.state.randomVerifyTokenGenerated !=="" && this.state.randomVerifyTokenGenerated !== this.state.randomVerifyTokenUser)}
              onClick={() => this.createLink(this.state.transferServiceId, this.state.serviceParamInbox)}>Setup</MuiCore.Button>
            </MuiCore.Grid>
            
          </MuiCore.Grid>
        </OutlinedPopover>

        <OutlinedPopover open={authorizeOpen}
              icon={<LinkIcon color='primary' fontSize='large'/>}
              title="Authorize Link"
              onClose={this.closeLink}>
              <MuiCore.Grid container style={{ width: 500}} spacing={2}>
            <MuiCore.Grid item xs={12} className={classes.linkBlurb}>
              {linkBlurb}
            </MuiCore.Grid>

            <MuiCore.Hidden xlDown={transferLink.transferKey !== 'CLIOGROW'}>
              <MuiCore.Grid item xs={12} className={classes.linkBlurb}>
               <div style={{ display: 'flex'}}>
                 <div style={{flexGrow: 1}}>
                   <MuiCore.FormControl fullWidth>
                     <MuiCore.TextField id="serviceParamToken"
                                        fullWidth
                                        variant="standard"
                                        InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                        placeholder="Inbox Token" value={this.state.serviceParamInbox} onChange={this.handleChange} />
                   </MuiCore.FormControl>                     
                 </div>
                 <div>
                   <MuiCore.IconButton color='primary'  onClick={(event) => {
                     this.setState({clioGrowHelpOpen: true, clioGrowHelpAnchor: event.target });
                   }}>
                     <HelpIcon/>
                   </MuiCore.IconButton>
                 </div>
               </div>
              </MuiCore.Grid>
            </MuiCore.Hidden>

            <MuiCore.Hidden xlDown={transferLink.transferKey !== 'EMAIL' && transferLink.transferKey !== 'INFLUXMD' && transferLink.transferKey !== 'TWILIO'}>
                    <MuiCore.Grid item xs={12}>
                      <div style={{ display: 'flex'}}>
                        <div style={{flexGrow: 1}}>
            
                          <MuiCore.FormControl fullWidth>
                            {/* <MuiCore.TextField id="email"
                                                fullWidth
                                                variant="standard"
                                                label="Email Address" value={this.state.email} onChange={this.handleEmailChange} /> */}

                              {(transferLink.transferKey === 'EMAIL' || transferLink.transferKey ==='INFLUXMD') && <MuiCore.TextField id="email"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                placeholder="Email Address" value={this.state.email} onChange={this.handleEmailChange} /> }

                              {transferLink.transferKey === 'INFLUXMD'  && <MuiCore.TextField id="apiKey"
                                                      fullWidth
                                                      variant="standard"
                                                      InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                      placeholder="Enter Api Key" value={this.state.apiKey} onChange={this.handleApiKeyChange} /> 
                              }

                              {transferService.transferKey === 'TWILIO' &&  <IntlTelInput  containerClassName="intl-tel-input"
                              inputClassName="MuiInputBase-input" preferredCountries={[]} defaultCountry={"us"} onlyCountries={['us','gb']} value={this.state.phone} onPhoneNumberChange={this.handleIntlPhoneChange} onSelectFlag={this.handleSelectFlag} />}


                             {/* {transferLink.transferKey === 'TWILIO' &&  <MuiCore.TextField id="phone"
                                                fullWidth
                                                variant="standard"
                                          label="Phone Number" value={this.state.phone} onChange={this.handlePhoneChange} /> } */}
                          </MuiCore.FormControl> 

                          <MuiCore.FormControl style={{marginTop:'6px'}}>
                          <MuiCore.Button disabled={this.state.randomVerifyTokenGenerated !=="" || !this.state.phoneValidation}
                           onClick={() => this.sendVerificationEmail()}>Verify</MuiCore.Button>
                        </MuiCore.FormControl>

                          {this.state.randomVerifyTokenGenerated && 
                          <MuiCore.FormControl fullWidth>
                            <MuiCore.TextField id="verifyToken"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 16}}}
                                                placeholder="Enter Verification Code" value={this.state.randomVerifyTokenUser} onChange={this.handleVerifyTokenChange} />
                          </MuiCore.FormControl>  
                          }     

                        </div>
                        <div>
                          <MuiCore.IconButton color='primary' onClick={(event) => {
                            this.setState({emailHelpOpen: true, emailHelpAnchor: event.target });
                          }}>
                            <HelpIcon/>
                          </MuiCore.IconButton>
                        </div>
                      </div>
                    </MuiCore.Grid>
              </MuiCore.Hidden>
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.Hidden xlDown={transferLink.pullService === 'Y'}>
                <MuiCore.Button
                  disabled={(transferLink.transferKey === 'CLIOGROW' && !this.state.serviceParamInbox) || (transferLink.transferKey==='EMAIL' && this.state.randomVerifyTokenGenerated ==="") || (transferLink.transferKey==='INFLUXMD' && this.state.randomVerifyTokenGenerated ==="") || (transferLink.transferKey==='EMAIL' && this.state.randomVerifyTokenGenerated !=="" && this.state.randomVerifyTokenGenerated !== this.state.randomVerifyTokenUser) }
                  onClick={() => this.refreshLink(transferLink,this.state.serviceParamInbox,this.state.email,this.state.phone,this.state.apiKey)}>
                  Authorize
                </MuiCore.Button>
              </MuiCore.Hidden>
              <MuiCore.Hidden xlDown={transferLink.pullService === 'N'}>
                <MuiCore.Button
                  onClick={() => this.setState({ authorizeOpen: false})}>
                  Close
                </MuiCore.Button>
              </MuiCore.Hidden>
            </MuiCore.Grid>
            
          </MuiCore.Grid>
        </OutlinedPopover>

        <OutlinedPopover open={customRulesOpen}
                         icon={<LinkIcon color='primary' fontSize='large'/>}
                         title="Automatic Transfers"
                         onClose={() => this.setState({ customRulesOpen : false }) }>
          
          <MuiCore.Grid container style={{ width: 500}} spacing={2}>
            <MuiCore.Grid item xs={12} className={classes.linkBlurb}>
              Please verify and remove all the custom transfer rules, before enabling the automatic transfers.
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.Button onClick={() => 
                {
                  var usedRulePhoneNumbers = [],usedRuleAccounts = [];
    
                          transferLink.transferRules.forEach(element => {
                            if(element.accountId){
                              usedRuleAccounts.push(element.accountId);
                            }
                            if(element.phoneNumberId){
                              usedRulePhoneNumbers.push(element.phoneNumberId);
                            }
                          });
                          this.setState({backFillOpen : false,customRulesOpen: false , linkMenuOpen: false,transferRuleMenuOpen:true,usedRulePhoneNumbers:usedRulePhoneNumbers,usedRuleAccounts:usedRuleAccounts})
                }
                  }>Open Modify rules</MuiCore.Button>
              {/* <MuiCore.Button style={{marginLeft: 10}}>Contact Customer Service</MuiCore.Button> */}
            </MuiCore.Grid>
            
          </MuiCore.Grid>
        </OutlinedPopover>
        
        <OutlinedPopover open={enableTransferOpen}
                         icon={<LinkIcon color='primary' fontSize='large'/>}
                         title="Automatic Transfers"
                         onClose={() => this.setState({ enableTransferOpen : false }) }>
          <MuiCore.Grid container style={{ width: 500}} spacing={2}>
            <MuiCore.Grid item xs={12} className={classes.linkBlurb}>
              Do you wish to start automatically sending all your messages to this service? 
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.Button onClick={this.enableTransfer}>Enable Automatic Transfer</MuiCore.Button>
            </MuiCore.Grid>
          </MuiCore.Grid>
        </OutlinedPopover>
        
        <OutlinedPopover open={disableTransferOpen}
                         icon={<LinkIcon color='primary' fontSize='large'/>}
                         title="Automatic Transfers"
                         onClose={() => this.setState({ disableTransferOpen : false }) }>
          <MuiCore.Grid container style={{ width: 500}} spacing={2}>
            <MuiCore.Grid item xs={12} className={classes.linkBlurb}>
              Do you wish to disable automatically sending all your messages to this service?  You will still
              be able to manually send messages from the activity list.
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.Button onClick={this.disableTransfer}>Disable Automatic Transfer</MuiCore.Button>
            </MuiCore.Grid>
            
          </MuiCore.Grid>
        </OutlinedPopover>
        
        <MuiCore.Grid className={classes.contentBox}>
          <div className={classes.contentScroller}>
            <div className={classes.controlPanel}>
              <div style={{paddingRight: 10,display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                {/* <LinkIcon fontSize='large'/> */}
                {/* <span style={{fontSize: 18, marginLeft: 15, fontFamily: 'Sofia-bold'}}>Service Links</span> */}
              </div>
              <div style={{flexGrow: 1}}></div>
             <MuiCore.Tooltip style={{fontSize:'14px'}} title="Create a new transfer link">
               <span>
               <MuiCore.Button onClick={this.newLink}>
                Add new
              </MuiCore.Button>
              </span>
              </MuiCore.Tooltip> 
            </div>
            {/* <div style={{flexGrow: 1, marginBottom: 20}}>
              Service links allow the secure transfer of your messages to one of our partner services. 
              You may transfer messages manually from your activity list or by selecting the automatic transfer option.
            </div> */}
            <div className={classes.linkList}>
              {transferLinks.map(transferLink => {
                let linkStatus=<MuiCore.Typography  style={{fontFamily: 'Sofia'}}>This link is up.</MuiCore.Typography>;
                let transferStatus='Manual Transfers';
                if (this.transferAll(transferLink)) {
                  transferStatus='Automatic transfers';
                }                  
                if (this.customTransfers(transferLink)) {
                  transferStatus='Customer transfer rules';
                }                  
                if (transferLink.settingUp === 'Y') {
                  linkStatus=<MuiCore.Typography  style={{fontFamily: 'Sofia'}}>ATTENTION: This link has not received authorization.</MuiCore.Typography>;
                } else {
                  if (transferLink.attention === 'Y') {
                    linkStatus=<MuiCore.Typography  style={{fontFamily: 'Sofia'}}>ATTENTION: {transferLink.message}</MuiCore.Typography>;
                  }
                }
                return(<div key={transferLink.transferLinkId}
                            className={classes.linkRow}>
                  <div className={classes.peopleIcon}>
                    <LinkIcon color='primary' fontSize='large'/>
                  </div>
                  <div className={classes.infoBlock}>
                    <div className={classes.name}>
                      {transferLink.serviceName}
                    </div>
                    <div className={classes.name}>
                      {transferStatus}  ({transferLink.sent} sent, {transferLink.queued} queued, {transferLink.retry} retryable, {transferLink.failed} failed)
                    </div>
                    <div className={classes.business}>
                      {(transferLink.transferKey==='EMAIL' || transferLink.transferKey==='INFLUXMD') && transferLink.parsedParametersJson && <MuiCore.Typography style={{fontFamily: 'Sofia'}}>{transferLink.parsedParametersJson.email}</MuiCore.Typography>}
                      {transferLink.transferKey==='TWILIO' && transferLink.parsedParametersJson && <MuiCore.Typography style={{fontFamily: 'Sofia'}}>{transferLink.parsedParametersJson.phone}</MuiCore.Typography>}
                      {linkStatus}
                    </div>
                  </div>
                  <div className={classes.menuBlock}>
                    <MuiCore.IconButton
                      onClick={(event) => this.openMenu(event, transferLink)}>
                      <ServiceIcons.MenuIcon/>
                    </MuiCore.IconButton>
                  </div>
                </div>)})}
            </div>
          </div>
        </MuiCore.Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    transferServices : serviceSelectors.getTransferServices(state),
  });
};

const mapDispatchToProps = {
  updateTransferServices : serviceActions.updateTransferServices,
  createTransferLink : serviceActions.createTransferLink,
  deleteTransferLink : serviceActions.deleteTransferLink,
  refreshTransferLink : serviceActions.refreshTransferLink,
  updateUser : coreActions.updateUser,
  enableAutomaticTransfers : serviceActions.enableAutomaticTransfers,
  disableAutomaticTransfers : serviceActions.disableAutomaticTransfers,
  backfillTransferLink : serviceActions.backfillTransferLink,
  sendVerificationCode : serviceActions.sendVerificationCode,
  addNewCustomTransferRule : serviceActions.addNewCustomTransferRule,
  deleteCustomTransferRule : serviceActions.deleteCustomTransferRule,
  importContacts: serviceActions.importContacts
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Links));

